<template>
  <div class="t1-header">
    <!-- <div class="navigation">
      <input type="checkbox" class="navigation__checkbox" v-model="checked" id="navi-toggle" />
      <label for="navi-toggle" class="navigation__button">
        <span class="navigation__icon">&nbsp;</span>
      </label>
    </div> -->
    <div class="t1-header__picture">
      <div class="pp-container">
        <img
          class="profile-pic"
          src="https://www.clubtresmarias.com/portal/wp-content/uploads/2015/08/logo-color.jpg"
          alt="Profile Picture"
        />
      </div>
      <p class="profile-name">{{ name }}</p>
      <div :class="openClass" style="position: absolute;right: 25px;width: 20px;">
        <input id="id-header" class="t1-header__checkbox" v-model="open" type="checkbox" />
        <label for="id-header"  class="t1-header__title-icon">
          <img src="../../../public/img/icons/accarr.svg" alt />
        </label>
      </div>
    </div>
    <div class="dropdown-admin" v-if="open" :class="dropDownClasses" style="height: 7rem !important; width: 220px;">
        <div class="t1-dropdown__options-admin" >
            <ul>
                <li @mousedown="logout">Cerrar sesión</li>
            </ul>
        </div>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
export default {
  props: ["name"],
  name: "HeaderAdmin",
  data() {
    return {
      open: false
    };
  },
  watch: {},
  computed: {
    ...mapGetters({
      getDropdown: "getDropdown"
    }),
    checked: {
      get() {
        return this.getDropdown;
      },
      set(value) {
        this.setDropdown(value);
      }
    },
    openClass() {
      return this.open ? " t1-header__title--open" : "";
    },
    dropDownClasses(){
                return `t1-dropdown${this.visible}`;
            },
            visible(){
                return this.open ? ` t1-dropdown--open-admin` : ``;
            },
  },
  methods: {
    ...mapActions(["logOut", "setDropdown"]),
            async logout() {
                await this.setDropdown(false);
                await this.logOut();
                this.$router.push('/');
            },
  }
};
</script>